import React from 'react';
import PropTypes from 'prop-types';
import {Auth0Provider} from '@auth0/auth0-react';
import Config from 'config';
import Auth0APISetupProvider from './Auth0APISetupProvider';

const AuthProvider = ({children}) => (
    <Auth0Provider
        domain={Config.auth0Domain}
        clientId={Config.auth0ClientID}
        audience={Config.auth0AudienceV1API}
        redirectUri={`${location.origin}/auth/callback`}
        scope="read:current_user update:current_user_metadata"
    >
        <Auth0APISetupProvider>{children}</Auth0APISetupProvider>
    </Auth0Provider>
);

AuthProvider.propTypes = {
    children: PropTypes.node,
};

export default AuthProvider;
